import type { useDesktopLandingData } from '../use-desktop-landing-data';
import { BottomMultipleOfferCard } from './bottom-multiple-offer-card';
import { ImmatureNeighbourhoodActions } from './immature-neighbourhood-actions';
import { LandingTrustBanners } from './landing-trust-banners';
import { NeighbourhoodSocialActions } from './neighbourhood-social-actions';

export function ImmatureNeighbourhoodSections({ data }: { data: ReturnType<typeof useDesktopLandingData> }) {
  const { user, showTopMultipleOfferCard, canBecomeAmbassador, insuredUsers, neighbourhoodStatus } = data;
  if (!neighbourhoodStatus) return null;

  return (
    <>
      <ImmatureNeighbourhoodActions neighbourhoodStatus={neighbourhoodStatus} />
      <BottomMultipleOfferCard showTopMultipleOfferCard={showTopMultipleOfferCard} />
      <NeighbourhoodSocialActions neighbourhoodStatus={neighbourhoodStatus} />
      <LandingTrustBanners canBecomeAmbassador={canBecomeAmbassador} insuredUsers={insuredUsers} user={user} />
    </>
  );
}
